import { apiGet } from '../utils';

const getLoginUrl = async () => {
    // const url = process.env.REACT_APP_PROFILE_CONNECT_URL;
    // return url;
    const url = 'api/login';
    return await apiGet(url);

};

const getToken = async params => {
    const url = `api/token?queryString=${params}`;
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        }
    };
    const response = await fetch(url, options);
    if (response.ok) {
        try {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            console.log(`Received token response: ${response.status} isJSON:${isJson}`);
            if (isJson) {
                // the response is not normally JSON as we usually use a cookie and just return 200 OK without a body
                const json = await response.json();
                return json.bearerAccessToken ? json.bearerAccessToken.value : response.ok;
            } else {
                // if there is no json body, we expect the token has been added to a http only cookie which is not
                // detectable by javascript.
                return response.ok;
            }

        } catch (err) {
            console.error('No expected token response, you could be using the wrong backend, proceeding without token: ', response.status, err, JSON.stringify(err));
            return response.ok;
        }
    } else {
        return false;
    }
};

const getUserInfo = async () => {
    const url = 'api/user/info';
    return await apiGet(url);
};

const logout = async () => {
    // we should always use the middle tier relative endpoint as we shouldn't configure the UI to know the
    // apigee endpoint so the MT can redirect to the startSLO endpoint since it knows the right apigee host
    // const urlBase = 'api';
    const url = 'api/sso-logout';
    return await apiGet(url);
};

export {
    getLoginUrl,
    getToken,
    getUserInfo,
    logout
};
